import React from 'react';
import { umoksType } from '../../../types/types.js';
import './topmenu.scss';
import { Link } from 'react-router-dom';

class TopMenu extends React.Component {
  constructor(props) {
    super(props);
    this.menuBtn = null;
    this.menuList = null;
  };

  componentWillMount() {
    this.props.onGetContent();
  };

  getMenuList = () => {
    const { menuList } = this.props;

    return menuList && menuList.map((item, i, arr) => {
      const menuText = item.item;

      const subMenu = () => {
        return item.submenu && item.submenu.map((sitem, i) => {
          return <li key = {'submenu-item-' + i}><Link to = {sitem.link}>{ sitem.item }</Link></li>;
        });
      };

      const menuItem =  item.submenu ? (() => {
        return <li key = {'menu-item-' + i}>{ menuText } <ul  className='submenu-list'> { subMenu() }</ul><i className='glyphicon glyphicon-triangle-bottom'  /></li>;
      })() :  <li key = {'menu-item-' + i}><Link to = {item.link}>{ menuText }</Link></li>;

      return  menuItem;
    });
  };

  menuAction = () => {
    this.menuList.classList.toggle('menu-visible');
  };

  render() {
    return (
      <nav  className='top-menu f-center'>
        <div className='f-container dell-margin'>
          <div className='f-row'>
            <div className='f-item f-item-12 f-start'>
              <div className='menu-wrap'>
                <div className='menu-btn-panel'>
                  <i ref={(i) => { this.menuBtn = i; }} onClick={this.menuAction} className='glyphicon glyphicon-th-list' />
                </div>
                <ul ref={(ul) => { this.menuList = ul; }} className='menu-list'>
                  {this.getMenuList()}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  };
};


TopMenu.propTypes = {
  menuList:  umoksType.isRequired
};

export default  TopMenu;



// WEBPACK FOOTER //
// ./src/client/components/header/topmenu/topmenu.jsx